import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import * as homeEndpointConst  from '../home-endpoints';
import * as homeConst from '../constants';
import { Observable } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class HomeService {
  // mangentoUrl = environment.apiURL
  baseUrl =  environment.apiURL;


  constructor(private http: HttpClient) { }

  getCtagories():Observable<any> {
    return this.http.post<any>(`${this.baseUrl}rest/V1/getCategories`, {});
  }

  getBrandsList():Observable<any> {
    return this.http.post<any>(`${this.baseUrl}rest/V3/${homeEndpointConst.BRANDS_LIST}`, {});
  }

  getStores(data):Observable<any> {
    return this.http.post<any>(`${this.baseUrl}rest/V1/storeList`, data);
  }
  checkStoreActive(data):Observable<any>{
    return this.http.post<any>(`${this.baseUrl}rest/V1/checkStoreActive`, data);
  }

  homeBanners(data):Observable<any>{
    return this.http.post<any>(`${this.baseUrl}rest/V1/homeBanners`, data);
  }

  retailerList(data):Observable<any>{
    return this.http.post<any>(`${this.baseUrl}rest/V1/retailerList`, data);
  }

  checkRetailerActive(data):Observable<any>{
    return this.http.post<any>(`${this.baseUrl}rest/V1/checkRetailerActive`, data);
  }
  

  dontMissSection(data):Observable<any>{
    return this.http.post<any>(`${this.baseUrl}rest/V1/dontMissSection`, data);
  }

  notInteretedSuggest(data):Observable<any>{
    return this.http.post<any>(`${this.baseUrl}rest/V1/notInteretedSuggest`, data);
  }

  sixBoxSection():Observable<any>{
    return this.http.post<any>(`${this.baseUrl}rest/V1/sixBoxSection`, {});
  }

  subBanners():Observable<any>{
    return this.http.post<any>(`${this.baseUrl}rest/V3/subBanners`, {});
  }

  topBanners():Observable<any>{
    return this.http.post<any>(`${this.baseUrl}rest/V3/topBanners`, {});
  }

  getGamificationBanner():Observable<any>{
    return this.http.post<any>(`${this.baseUrl}rest/V3/getGamificationBanner`, {});
  }
  
  webPromoBanner():Observable<any>{
    return this.http.post<any>(`${this.baseUrl}rest/V3/getUserPromotions`, {});
  }

  addDeal(data):Observable<any>{
    return this.http.post<any>(`${this.baseUrl}rest/V3/addDeal`,data);
  }

  sendSms(data):Observable<any>{
    return this.http.post<any>(`${this.baseUrl}web/v3/app/send-sms/`, data);
  }

  newProductSection(data):Observable<any>{
    return this.http.post<any>(`${this.baseUrl}rest/V2/getAllProducts`, data);
  }

  removeDeal(data):Observable<any>{
    return this.http.post<any>(`${this.baseUrl}rest/V3/removeDeal`, data);
  }


  //--------------helper methods ---------------------------------------


  getBrandsByCategory(brands:Array<any>):any{

    let brandsObj = {
      topBrands :[],
      brandsList :[]
    }

    const topBrands = brands.filter(brand => brand.top_brand);
    const nonTopBrands = brands.filter(brand => !brand.top_brand);

    brandsObj.topBrands = [...topBrands];
    brandsObj.brandsList = [...nonTopBrands];
    return brandsObj

  }

  groupBrandsByAlphabet(brands: Brand[]) {
  const groupRanges = [
    { from: homeConst.BRANDNAMES['A_TO_E'], range: ['A', 'B', 'C', 'D', 'E'], brands: [] as Brand[] },
    { from: homeConst.BRANDNAMES['F_TO_J'], range: ['F', 'G', 'H', 'I', 'J'], brands: [] },
    { from: homeConst.BRANDNAMES['K_TO_O'], range: ['K', 'L', 'M', 'N', 'O'], brands: [] },
    { from: homeConst.BRANDNAMES['P_TO_U'], range: ['P', 'Q', 'R', 'S', 'T', 'U'], brands: [] },
    { from: homeConst.BRANDNAMES['V_TO_Z'], range: ['V', 'W', 'X', 'Y', 'Z'], brands: [] },
    { from: homeConst.BRANDNAMES['BRAND'], range: ['#'], brands: [] }
  ];

  const alphaMap = new Map<string, Brand[]>();

  // Step 1: Group all brands by first letter (or #)
  brands.forEach(brand => {
    const label = brand.label?.trim() || '';
    const firstChar = label.charAt(0).toUpperCase();
    const alphaKey = /^[A-Z]$/.test(firstChar) ? firstChar : '#';

    if (!alphaMap.has(alphaKey)) {
      alphaMap.set(alphaKey, []);
    }
    alphaMap.get(alphaKey)!.push(brand);
  });

  // Step 2: For each letter in a-z or #, add a heading and its brands to the group
  const allLetters = [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ', '#'];

  allLetters.forEach(letter => {
    const group = groupRanges.find(gr => gr.range.includes(letter));
    if (group) {
      const brandsUnderLetter = alphaMap.get(letter) || [];
      if (brandsUnderLetter.length) {
        // First add the alphabet header object
        group.brands.push({ id: '', label: letter });
        // Then add the brands under this letter
        group.brands.push(...brandsUnderLetter.sort((a, b) => a.label.localeCompare(b.label)));
      }
    }
  });

  return groupRanges;
}


    groupBrandsByAlpModal(brands:Array<any>) :Array<any>{
    const letters = [...'abcdefghijklmnopqrstuvwxyz', '#'];
    const grouped = letters.reduce((acc, letter) => {
      acc[letter] = [];
      return acc;
    }, {} as { [key: string]: any[] });
    
    // Now fill the grouped object with real data
    brands.forEach(brand => {
      if (!brand.label || typeof brand.label !== 'string') return;
    
      const firstChar = brand.label.trim().charAt(0);
      let key = /[a-zA-Z]/.test(firstChar) ? firstChar.toLowerCase() : '#';
    
      grouped[key].push(brand);
    });
    
    // Convert to final sorted array
    const result = Object.keys(grouped)
      .sort((a, b) => {
        if (a === '#') return 1;
        if (b === '#') return -1;
        return a.localeCompare(b);
      })
      .map(key => ({
        alphabet: key.toUpperCase(),
        brands: grouped[key]
      }));
      
        return result;
    }


    //---------------group filter in filter modal
    groupBrands(brands:Array<any>):Array<any>{
      const seenLabels = new Set();
  const uniqueBrands = [];

  // Deduplicate by label (case-insensitive)
  for (const brand of brands) {
    const label = brand.label?.trim().toLowerCase();
    if (!label) continue;

    if (!seenLabels.has(label)) {
      seenLabels.add(label);
      uniqueBrands.push(brand);
    }
  }

  const grouped = {};
  [...'abcdefghijklmnopqrstuvwxyz','#'].forEach(letter => {
    grouped[letter] = [];
  });

  // Group brands by first letter or #
  uniqueBrands.forEach(brand => {
    const firstChar = brand.label.trim().charAt(0).toLowerCase();
    const key = /^[a-z]$/.test(firstChar) ? firstChar : '#';
    grouped[key].push(brand);
  });

  // Create flat list
  const output = [];
  for (const key of [...'abcdefghijklmnopqrstuvwxyz','#']) {
    const brandsInGroup = grouped[key];
    if (brandsInGroup.length) {
      output.push({ id: '', label: key.toUpperCase() });
      output.push(...brandsInGroup);
    }
  }

    return output;
    }

}




interface Brand  { label: string; id: any };
